import React from 'react';
import { Link } from 'react-router-dom';
import {
  BadgeCheck, BookOpen, BriefcaseBusiness, CalendarDays, Contact,
  FileText, Gift, IdCard, Megaphone, Presentation, Smartphone, Sticker
} from 'lucide-react';
import PageHeader from '../components/ui/PageHeader';
import { useI18n } from '../i18n/I18nContext';
import './StaticPage.css';

const CATEGORY_META = [
  { icon: BriefcaseBusiness, color: '#3157d5' },
  { icon: IdCard, color: '#147d70' },
  { icon: Contact, color: '#a44c58' },
  { icon: CalendarDays, color: '#9b6b14' },
  { icon: Presentation, color: '#97508a' },
  { icon: Megaphone, color: '#3972a9' },
  { icon: Smartphone, color: '#644fa3' },
  { icon: FileText, color: '#287b8a' },
  { icon: BookOpen, color: '#417a58' },
  { icon: BadgeCheck, color: '#9a5e31' },
  { icon: Sticker, color: '#5362a8' },
  { icon: Gift, color: '#9c506f' },
];

const ServicesPage: React.FC = () => {
  const { content } = useI18n();
  const services = content.services;

  return (
    <div className="static-page">
      <PageHeader page="services" />
      <main className="container static-page__body">
        <div className="services-grid">
          {services.categories.map((category, index) => {
            const { icon: Icon, color } = CATEGORY_META[index];
            return (
              <article key={category.title} className="services-card" style={{ '--card-color': color } as React.CSSProperties}>
                <div className="services-card__icon"><Icon size={19} strokeWidth={1.7} /></div>
                <h2 className="services-card__title">{category.title}</h2>
                <p className="services-card__desc">{category.description}</p>
              </article>
            );
          })}
        </div>
        <div className="static-page__cta">
          <div><h2>{services.ctaTitle}</h2><p>{services.ctaText}</p></div>
          <Link to="/request" className="btn btn-primary">{services.cta}</Link>
        </div>
      </main>
    </div>
  );
};

export default ServicesPage;
